import { Linkedin, Twitter, Instagram, Github } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import Logo from "./Logo";

const SOCIALS = [
  { Icon: Linkedin, label: "LinkedIn", href: "#" },
  { Icon: Twitter, label: "Twitter", href: "#" },
  { Icon: Instagram, label: "Instagram", href: "#" },
  { Icon: Github, label: "GitHub", href: "#" },
];

const LINKS = [
  { key: "home", path: "/" },
  { key: "services", path: "/services" },
  { key: "about", path: "/about" },
  { key: "contact", path: "/contact" },
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      className="relative border-t border-[rgba(0,240,255,0.15)] bg-[#050B14]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 text-slate-400 text-sm max-w-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-tech text-[11px] uppercase tracking-[0.28em] text-[#00F0FF] mb-5">
            {t.footer.links}
          </p>
          <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
            {LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-link-${l.key}`}
                  className="text-sm text-slate-300 hover:text-[#00F0FF] transition-colors"
                >
                  {t.nav[l.key]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-tech text-[11px] uppercase tracking-[0.28em] text-[#00F0FF] mb-5">
            {t.footer.follow}
          </p>
          <div className="flex gap-3">
            {SOCIALS.map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="w-10 h-10 inline-flex items-center justify-center border border-white/10 text-slate-300 hover:text-[#00F0FF] hover:border-[#00F0FF] transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500 font-mono-tech tracking-wider">
            © 2026 WOSOL TECH — {t.footer.rights}
          </p>
          <p className="text-[10px] text-slate-600 font-mono-tech tracking-[0.3em] uppercase">
            v1.0 / Online
          </p>
        </div>
      </div>
    </footer>
  );
}
